import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, Params, Router} from '@angular/router';
import 'rxjs/add/operator/switchMap';
import {WindowRefService} from "../infrastructure/services";


@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit {
  private nativeWindow: any;
  constructor(  private route: ActivatedRoute,
                private router: Router,
                private winRef: WindowRefService,
                private location: Location) {
    this.nativeWindow = winRef.getNativeWindow();
  }
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.nativeWindow.open((params['externalLink']));
      this.location.back();
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/app/redirect/redirect.component.ts